import React from 'react';
import styles from './index.module.scss'
// import Logo from '../../../images/logo.png'

const Loading = (props) => {
  const {compData} = props;

  return (
    <div className={styles.wrapper}>
      <div>
        <div className={styles.loader}></div>
        <img src={`${process.env.PUBLIC_URL}/images/logo.png`} loading="lazy"/>
      </div>
    </div>
  );
};

export default Loading;
